<app-spinner [isLoading]="isLoading$ | async">
    @if ({
        companies: companies$ | async,
        customerCount: customerCount$ | async,
        website: website$ | async,
        isLoading: isLoading$ | async
    }; as data) {
        <div class="page">
            <div class="page__inner">
                <h1 class="page__title">{{ 'label.Companies' | translate }}</h1>

                <div class="page__description"
                     [innerHTML]="'text.CompaniesPageDescription' | translate : { customerCount: data.customerCount, website: data.website?.displayName } | safeHtml"></div>

                @if (data.companies?.length > 0) {
                    <div class="companies">
                        @for (company of data.companies; track company.customerId) {
                            <app-customer-list-item [company]="company"></app-customer-list-item>
                        }
                    </div>

                    @if ({
                        pageCount: pageCount$ | async,
                        navItems: navItems$ | async,
                        currentPage: currentPage$ | async
                    }; as paging) {
                        <div class="page__paging">
                            <app-paging [currentPage]="paging.currentPage"
                                        [pageCount]="paging.pageCount"
                                        [pagingNavItems]="paging.navItems"
                                        (onPageNav)="onPagignNavigation($event)"></app-paging>
                        </div>
                    }
                } @else if (!data.isLoading) {
                    <div class="empty">
                        <p class="empty__text">{{ 'label.CompaniesNotFound' | translate }}</p>
                    </div>
                }
            </div>
        </div>
    }
</app-spinner>
